<template>
    <button
        type="button"
        class="group ic-btn"
        v-bind="$attrs"
    >
        <slot />
    </button>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>
